import { gql, useMutation } from '@apollo/client'

import { cleanRequest } from './cleanRequest'
import { templatesClient } from '../../../../utils/apollo/api'
import { useEntityRootNavigation } from '../../../../utils/routes/entityRoot'
import { useTemplate } from '../_load/TemplateLoader'

const MUTATION = gql`
  mutation UpsertTemplate($input: TemplateInput) {
    upsertTemplate(input: $input) {
      id
    }
  }
`

const validate = (form, setErrors) => {
  const errors = [
    // ...appendIf(!form.name, { path: ['name'], message: 'Campo obrigatório' })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveTemplate = () => {
  const { entity } = useTemplate() || {}
  const navigatgeToHome = useEntityRootNavigation(entity)
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Template'], client: templatesClient })

  const handleRequest = (form, actions) => {
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      const input = cleanRequest(form)
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          navigatgeToHome()
        }
      })
    }
  }

  return [handleRequest, state]
}
